import { render, staticRenderFns } from "./pengumuman.vue?vue&type=template&id=0ed6c1fe&"
import script from "./pengumuman.vue?vue&type=script&lang=js&"
export * from "./pengumuman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports